// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ReactPortal from "react-portal";
import * as Base$Showside from "../Base.bs.js";
import * as Theme$Showside from "../types/Theme.bs.js";
import * as ThemeId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/ThemeId.bs.js";
import * as UseIsPLP$Showside from "../hook/UseIsPLP.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ThemeDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/ThemeDecoders.bs.js";
import * as RouterProvider$Showside from "./RouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "./ConfigurationProvider.bs.js";
var Portal = {};
var context = React.createContext(ThemeDecoders$ApiTypes.empty);
var provider = context.Provider;
function getThemeFromReference(themes, reference) {
  return Belt_Array.getBy(themes, function (t) {
    if (reference !== undefined && reference) {
      return Caml_obj.equal(reference._0, t.themeId);
    } else {
      return false;
    }
  });
}
function useLocalTheme(param) {
  return React.useContext(context);
}
function BaseWithTheme(Props) {
  var initiator = Props.initiator;
  var style = Props.style;
  var reference = Props.reference;
  var classNameOpt = Props.className;
  var portal = Props.portal;
  var children = Props.children;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var match$2 = match$1.settings;
  var pdpTheme = match$2.pdpTheme;
  var plpTheme = match$2.plpTheme;
  var baseTheme = match$2.theme;
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var isPLP = UseIsPLP$Showside.useIsPLP(undefined);
  var isPDP = Belt_Option.isSome(match$3.anyProductId);
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, match$1.categories);
  var activeCategoryTheme = Belt_Option.map(Belt_Option.orElse(activeCategory, match$2.indexNode), function (category) {
    return category.pageTheme;
  });
  var accountThemes = Belt_Option.map(match$1.transitiveAccount, function (account) {
    return account.themes;
  });
  var propTheme = React.useMemo(function () {
    return Belt_Option.flatMap(accountThemes, function (themes) {
      return getThemeFromReference(themes, reference);
    });
  }, [accountThemes, reference]);
  var pdpTheme$1 = React.useMemo(function () {
    return Belt_Option.keep(pdpTheme, function (param) {
      return isPDP;
    });
  }, [pdpTheme, isPDP]);
  var plpTheme$1 = React.useMemo(function () {
    return Belt_Option.keep(plpTheme, function (param) {
      return isPLP;
    });
  }, [plpTheme, isPLP]);
  var pageTheme = React.useMemo(function () {
    return Belt_Option.flatMap(accountThemes, function (themes) {
      return getThemeFromReference(themes, activeCategoryTheme);
    });
  }, [accountThemes, activeCategoryTheme]);
  var theme = React.useMemo(function () {
    return Belt_Option.getWithDefault(Belt_Option.orElse(Belt_Option.orElse(Belt_Option.orElse(propTheme, pdpTheme$1), pageTheme), plpTheme$1), baseTheme);
  }, [propTheme, pdpTheme$1, plpTheme$1, pageTheme, baseTheme]);
  var style$1 = React.useMemo(function () {
    return Theme$Showside.combineMaybe(Theme$Showside.makeStyle(theme), style);
  }, [theme.themeUpdatedAt]);
  var children$1 = React.createElement(DataAttribute$Showside.make, {
    dataId: "maker-theme-" + Curry._1(ThemeId$ApiTypes.toString, theme.themeId),
    dataInitiator: initiator,
    children: React.createElement("div", {
      className: Cn.make([Base$Showside.getClassName(undefined), className]),
      style: style$1
    }, React.createElement(provider, {
      value: theme,
      children: children
    }))
  });
  if (portal) {
    return React.createElement(ReactPortal.Portal, {
      children: children$1
    });
  } else {
    return children$1;
  }
}
BaseWithTheme.displayName = "BaseWithTheme";
var make = BaseWithTheme;
export { Portal, context, provider, getThemeFromReference, useLocalTheme, make };
/* context Not a pure module */